import React from "react";
import { useTranslation } from "react-i18next";

const Pill = ({ children }) => <span className="pill-badge">{children}</span>;

export default function Header() {
  const { t } = useTranslation();

  return (
    <header id="about" className="header1">
      <div className="container1 hero-inner">

        {/* Photo column */}
        <div className="hero-photo-col">
          <img className="img-fluid profile-img hero-animate" src="img/prof.png" alt="Alexander Aprelkin" style={{ animationDelay: "0s" }} />
        </div>

        {/* Text column */}
        <div className="hero-text-col">
          <h1 className="myname hero-animate" style={{ animationDelay: "0.08s" }}>Alexander Aprelkin</h1>

          <p className="hero-headline hero-animate" style={{ marginTop: "0.5rem", animationDelay: "0.15s" }}>
            {t('hero.headline')}
          </p>

          <p className="hero-keywords hero-animate" style={{ marginTop: "0.75rem", animationDelay: "0.22s" }}>
            {t('hero.keywords')}
          </p>

          <div className="ai-focus-banner ai-focus-banner--stacked hero-animate" style={{ marginTop: "0.9rem", animationDelay: "0.36s" }}>
            <div className="ai-focus-banner-title">
              <span>{t('hero.aiHintTitle')}</span>
            </div>
            <div className="ai-focus-banner-sub">{t('hero.aiHintSub')}</div>
          </div>

          <div className="hero-pills hero-animate" style={{ marginTop: "0.9rem", animationDelay: "0.42s" }}>
            <Pill>{t('hero.pills.java')}</Pill>
            <Pill>{t('hero.pills.react')}</Pill>
            <Pill>{t('hero.pills.kafka')}</Pill>
            <Pill>{t('hero.pills.cloud')}</Pill>
            <Pill>{t('hero.pills.payments')}</Pill>
          </div>

          <div className="cta-group hero-animate" style={{ marginTop: "1.25rem", animationDelay: "0.56s" }}>
            <a href="#contact" className="btn-cta2 cta-blue">{t('hero.ctaContact')}</a>
            <a href="#projects" className="btn-cta2 cta-green">{t('hero.ctaProjects')}</a>
          </div>

          <div className="hero-meta hero-animate" style={{ marginTop: "1rem", animationDelay: "0.62s" }}>
            <div style={{ marginBottom: ".4rem" }}>{t('hero.availability')}</div>
            <div className="language-flags">
              <img src="/img/icons8-germany-48.png" alt="Deutsch" />
              <span style={{ opacity: ".7" }}> | </span>
              <img src="/img/icons8-usa-48.png" alt="English" />
              <div className="subline" style={{ marginTop: ".3rem" }}>
                {t('hero.languages')}
              </div>
            </div>
          </div>
        </div>

      </div>
    </header>
  );
}
